__turbopack_context__.v({
  "error": "b2c-commodity-lead-form-module-scss-module__dmSmbW__error",
  "form": "b2c-commodity-lead-form-module-scss-module__dmSmbW__form",
  "placeholder": "b2c-commodity-lead-form-module-scss-module__dmSmbW__placeholder",
  "section": "b2c-commodity-lead-form-module-scss-module__dmSmbW__section",
});
